@if (modeView != ModeView.CREATE && variable?.allowsFormula) {
	@if (!variable.formula) {
		<div class="col d-flex">
			<button class="btn btn-outline-info" (click)="add()" [disabled]="modeView === ModeView.EDIT">
				<i class="fa fa-asterisk fa-md"></i>&nbsp;
				<span style="margin-left: 5px;" jhiTranslate="ontology-manager.variable.formula.new"> New Formula</span>
			</button>
		</div>
	} @else {
		<div class="underlined-heading">
			<h5>
				<div class="d-flex align-items-center"
					 role="button" tabindex="0" (click)="toggle()" style="cursor: pointer; user-select: none;">
					<span
						[ngClass]="isFormulaExpanded ? 'fa fa-caret-up fa-rotate-180' : 'fa fa-caret-up fa-rotate-90'"
						style="margin-right: 5px; color: rgb(51, 122, 183);">
					</span>
					<span class="control-label fw-bold" jhiTranslate="ontology-manager.variable.formula.title">
					</span>
				</div>
			</h5>
		</div>
		@if (isFormulaExpanded) {
			<br>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th><span jhiTranslate="ontology-manager.variable.formula.calculation"></span></th>
					<th><span jhiTranslate="ontology-manager.variable.formula.input.variables"></span></th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td>
						<truncate-span [textInput]="variable?.formula?.definition"></truncate-span>
					</td>
					<td style="max-width: 400px; word-wrap: break-word; white-space: normal;">
						<span *ngIf="!variable.formula.inputs ||  variable.formula.inputs.length === 0"> - </span>
						<span *ngIf="variable.formula?.inputs">
							<span *ngFor="let input of variable.formula?.inputs; let last = last;">
								<span class="me-2">
									<a href="javascript:void(0)" (click)="openlink(input)">
										<truncate-span [textInput]="input?.name"></truncate-span>
									</a>
								</span>
							</span>
						</span>
					</td>
					<td class="text-center">
						<button class="btn btn-sm btn-outline-info me-2" [disabled]="modeView === ModeView.EDIT" (click)="edit()">
							<span class="fa fa-edit fa-md"></span>&nbsp;
						</button>
						<button class="btn btn-sm btn-outline-info me-2" [disabled]="modeView === ModeView.EDIT" (click)="delete(variable.formula)">
							<span class="fa fa-trash fa-md"></span>&nbsp;
						</button>
					</td>
				</tr>
				</tbody>
			</table>
		}
	}
}
